import React from "react";
import loginLogo from "../../assets/svgs/loginLogo.svg";
import christmasLogo from "../../assets/svgs/christmasLogoSingle.svg";
import christmasLight from "../../assets/images/bannerLight.png";
import styles from "./auth_style.module.css";
import { checkIfChristmasPeriod } from "../../utils/checkIfChristmasPeriod";
import { Link } from "react-router-dom/cjs/react-router-dom";

export default function AuthPageWrapper({ children }) {
	const isChristmas = checkIfChristmasPeriod();

	return (
		<div
			className={`${styles.auth_container} d-flex justify-content-center text-center align-items`}
		>
			<div className={`${styles.auth_card} bg-white`}>
				{isChristmas && (
					<div className={styles.christmasLightContainer}>
						<img
							src={christmasLight}
							alt="christmas Light"
							className={`${styles.light}`}
						/>
					</div>
				)}
				<div className={`mt-5 pt-2 ${styles.logo}`}>
					<Link to="/">
						<img
							src={isChristmas ? christmasLogo : loginLogo}
							alt="Futo Logo"
							className={`${styles.loginLogo}`}
						/>
					</Link>
				</div>
				{children}
			</div>
		</div>
	);
}
